module.exports = __webpack_public_path__ + "img/cam-overlay-top.14e3a6de.svg";